import '@yandex-delivery/ui/variables.css'

import React from 'react'
import {HelmetProvider} from 'react-helmet-async'

import {QueryClientProvider} from './QueryClientProvider'

const Application: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <HelmetProvider>
    <QueryClientProvider>{children}</QueryClientProvider>
  </HelmetProvider>
)

Application.displayName = 'Application'

export {Application}
